import { render, staticRenderFns } from "./preventistProducts.vue?vue&type=template&id=e4bc292e"
import script from "./preventistProducts.vue?vue&type=script&lang=js"
export * from "./preventistProducts.vue?vue&type=script&lang=js"
import style0 from "./preventistProducts.vue?vue&type=style&index=0&id=e4bc292e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports